import { CheckCircle } from "lucide-react";

const ABOUT_IMAGE = "https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg";

export default function OverFitSmith() {
  return (
    <section id="over" data-testid="about-section" className="py-20 lg:py-28 bg-[#0d0d0d]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="about-img-wrap">
              <img src={ABOUT_IMAGE} alt="FitSmith" className="w-full h-[420px] lg:h-[520px] object-cover rounded-2xl grayscale" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/60 via-transparent to-transparent rounded-2xl" />
              <div className="about-stat-badge">
                <div className="text-2xl font-bold text-white">25+</div>
                <div className="text-xs text-zinc-400">Tevreden cursisten</div>
              </div>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <p className="overline mb-4">Over ons merk</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">Over FitSmith</h2>
            <p className="text-zinc-300 text-base leading-relaxed mb-6">
              FitSmith staat voor duidelijke, hoogwaardige fitnessproducten waarmee je niet hoeft te gokken, maar gericht kunt werken aan resultaat.
            </p>
            <p className="text-zinc-400 text-sm leading-relaxed mb-8">
              Elk product dat we maken, is gebaseerd op bewezen trainingsmethodes en jarenlange praktijkervaring. Wij geloven dat iedereen — beginner of gevorderde — verdient om met de juiste tools te kunnen werken.
            </p>
            <div className="space-y-3">
              {["Ontwikkeld op basis van wetenschappelijk onderzoek", "Getest in de praktijk door echte sporters", "Helder, overzichtelijk en direct toepasbaar"].map(item => (
                <div key={item} className="flex items-center gap-3">
                  <CheckCircle size={16} className="text-[#C9A84C] shrink-0" />
                  <span className="text-zinc-300 text-sm">{item}</span>
                </div>
              ))}
            </div>
            <button onClick={() => document.querySelector("#aanbod")?.scrollIntoView({ behavior: "smooth" })}
              className="btn-gold mt-8 px-7 py-3.5 font-bold text-sm uppercase tracking-wide">
              Bekijk het aanbod
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
